import { rem } from "./auth-service-tools172.js";
import "react";
import "./auth-service-tools177.js";

function spacingResolver(value, theme) {
  if (typeof value === "number") {
    return rem(value);
  }

  if (typeof value === "string") {
    const mod = value.replace("-", "");

    if (!(mod in theme.spacing)) {
      return rem(value);
    }

    const variable = `--mantine-spacing-${mod}`;
    return value.startsWith("-") ? `calc(var(${variable}) * -1)` : `var(${variable})`;
  }

  return value;
}

export { spacingResolver };